import { useQuery } from '@tanstack/react-query';

import { fetchVocabularies, type VocabularyInfoDto } from '@/api/vocabularies';

/**
 * Catalogue entry for one vocabulary (display config, name, version, …), read from
 * `GET /api/v1/vocabularies`. Shares the `['vocabularies', 'catalogue']` query key with
 * the admin page so the fetch is deduped/cached. Lets the term picker render rich info
 * from just a `vocabularyId`, without each caller threading `display`/name/version.
 */
export function useVocabularyInfo(vocabularyId: string): VocabularyInfoDto | null {
  const query = useQuery({
    queryKey: ['vocabularies', 'catalogue'],
    queryFn: ({ signal }) => fetchVocabularies(signal),
    staleTime: 60_000,
  });
  return query.data?.find((v) => v.id === vocabularyId) ?? null;
}
